import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Gift, X, ArrowRight } from "lucide-react";
import { API } from "../App";
import { useLanguage } from "../contexts/LanguageContext";

const WelcomePromoBanner = ({ user }) => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const [activeCode, setActiveCode] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (user) return;
    const fetchActive = async () => {
      try {
        const res = await axios.get(`${API}/public/welcome-promo`);
        if (res.data?.active && res.data?.code) setActiveCode(res.data);
      } catch { /* silent */ }
    };
    fetchActive();
  }, [user]);

  if (user || dismissed || !activeCode) return null;

  const isFr = language === "fr";
  const discount = activeCode.discount_rate || 100;
  const isFree = discount >= 100;

  return (
    <div data-testid="welcome-promo-banner" className="fixed bottom-4 right-4 left-4 sm:left-auto sm:right-6 sm:bottom-6 z-50 max-w-md animate-in slide-in-from-bottom-5 fade-in duration-500">
      <div className="relative bg-brand-700 rounded-2xl shadow-2xl p-5 ring-2 ring-brand-800/40">
        <button
          onClick={() => setDismissed(true)}
          aria-label="Dismiss"
          data-testid="welcome-promo-dismiss"
          className="absolute top-3 right-3 p-1.5 rounded-full text-white/70 hover:text-white hover:bg-white/15 transition-colors"
        >
          <X className="h-4 w-4" />
        </button>

        <div className="flex items-start gap-4 pr-6">
          <div className="flex-shrink-0 bg-white/15 rounded-xl p-2.5">
            <Gift className="h-5 w-5 text-white" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-[10px] font-bold uppercase tracking-wider text-white/80 mb-1.5">
              {isFr ? "Offre de bienvenue" : "Welcome offer"}
            </p>
            <h3 className="text-white text-base font-bold leading-tight mb-2">
              {isFree
                ? isFr ? "Votre 1ère transaction est offerte" : "Your 1st transaction is on us"
                : isFr ? `${discount}% sur votre 1ère transaction` : `${discount}% off your 1st transaction`}
            </h3>
            <p className="text-xs text-white/85 mb-3">
              {isFr ? "Code " : "Code "}
              <code className="bg-white/20 text-white px-2 py-0.5 rounded font-mono font-bold text-[11px]" data-testid="welcome-promo-code">
                {activeCode.code}
              </code>
            </p>
            <button onClick={() => navigate("/auth")} data-testid="welcome-promo-cta" className="group inline-flex items-center gap-1.5 bg-white text-brand-800 hover:bg-white/95 font-bold text-sm px-3.5 py-1.5 rounded-md transition-colors">
              {isFr ? "Créer mon compte" : "Create my account"}
              <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomePromoBanner;
